var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 186,
    viewBox: "0 0 300 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M231.055 323.109C358.11 323.109 461.109 220.11 461.109 93.0547C461.109 -34.001 358.11 -137 231.055 -137C103.999 -137 1 -34.001 1 93.0547C1 220.11 103.999 323.109 231.055 323.109Z",
    stroke: "#242423",
    strokeOpacity: 0.16,
    strokeWidth: 0.8127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M231.057 306.332C348.846 306.332 444.334 210.844 444.334 93.0548C444.334 -24.7348 348.846 -120.222 231.057 -120.222C113.267 -120.222 17.7798 -24.7348 17.7798 93.0548C17.7798 210.844 113.267 306.332 231.057 306.332Z",
    stroke: "#242423",
    strokeOpacity: 0.16,
    strokeWidth: 0.9493,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M231.055 289.553C339.578 289.553 427.554 201.577 427.554 93.0538C427.554 -15.4696 339.578 -103.445 231.055 -103.445C122.531 -103.445 34.5554 -15.4696 34.5554 93.0538C34.5554 201.577 122.531 289.553 231.055 289.553Z",
    stroke: "#242423",
    strokeOpacity: 0.16,
    strokeWidth: 1.0859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M231.052 272.777C330.31 272.777 410.774 192.313 410.774 93.0553C410.774 -6.20208 330.31 -86.666 231.052 -86.666C131.795 -86.666 51.3311 -6.20208 51.3311 93.0553C51.3311 192.313 131.795 272.777 231.052 272.777Z",
    stroke: "#242423",
    strokeOpacity: 0.16,
    strokeWidth: 1.2225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M231.053 255.997C321.045 255.997 393.997 183.045 393.997 93.0534C393.997 3.06215 321.045 -69.8901 231.053 -69.8901C141.062 -69.8901 68.1099 3.06215 68.1099 93.0534C68.1099 183.045 141.062 255.997 231.053 255.997Z",
    stroke: "#242423",
    strokeOpacity: 0.16,
    strokeWidth: 1.3591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M231.054 239.221C311.779 239.221 377.22 173.78 377.22 93.0549C377.22 12.3298 311.779 -53.1108 231.054 -53.1108C150.329 -53.1108 84.8884 12.3298 84.8884 93.0549C84.8884 173.78 150.329 239.221 231.054 239.221Z",
    stroke: "#242423",
    strokeOpacity: 0.16,
    strokeWidth: 1.4956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M231.056 222.444C302.515 222.444 360.444 164.515 360.444 93.056C360.444 21.597 302.515 -36.332 231.056 -36.332C159.597 -36.332 101.668 21.597 101.668 93.056C101.668 164.515 159.597 222.444 231.056 222.444Z",
    stroke: "#242423",
    strokeOpacity: 0.16,
    strokeWidth: 1.6322,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M231.058 205.665C293.251 205.665 343.668 155.247 343.668 93.0546C343.668 30.8617 293.251 -19.5557 231.058 -19.5557C168.865 -19.5557 118.448 30.8617 118.448 93.0546C118.448 155.247 168.865 205.665 231.058 205.665Z",
    stroke: "#242423",
    strokeOpacity: 0.16,
    strokeWidth: 1.7688,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M231.054 188.916C283.996 188.916 326.914 145.998 326.914 93.0552C326.914 40.1127 283.996 -2.80566 231.054 -2.80566C178.111 -2.80566 135.193 40.1127 135.193 93.0552C135.193 145.998 178.111 188.916 231.054 188.916Z",
    stroke: "#242423",
    strokeOpacity: 0.16,
    strokeWidth: 1.9054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M231.055 172.137C274.732 172.137 310.138 136.73 310.138 93.0538C310.138 49.3774 274.732 13.9707 231.055 13.9707C187.379 13.9707 151.972 49.3774 151.972 93.0538C151.972 136.73 187.379 172.137 231.055 172.137Z",
    stroke: "#242423",
    strokeOpacity: 0.16,
    strokeWidth: 2.042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M231.056 155.36C265.467 155.36 293.362 127.465 293.362 93.0543C293.362 58.6441 265.467 30.749 231.056 30.749C196.646 30.749 168.751 58.6441 168.751 93.0543C168.751 127.465 196.646 155.36 231.056 155.36Z",
    stroke: "#242423",
    strokeOpacity: 0.16,
    strokeWidth: 2.1786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M231.055 138.58C256.2 138.58 276.583 118.197 276.583 93.0528C276.583 67.9087 256.2 47.5254 231.055 47.5254C205.911 47.5254 185.528 67.9087 185.528 93.0528C185.528 118.197 205.911 138.58 231.055 138.58Z",
    stroke: "#242423",
    strokeOpacity: 0.16,
    strokeWidth: 2.3152,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208 69H256C256.707 69 257.386 69.281 257.886 69.781C258.386 70.2811 258.667 70.9594 258.667 71.6667V114.333C258.667 115.041 258.386 115.719 257.886 116.219C257.386 116.719 256.707 117 256 117H208C207.293 117 206.615 116.719 206.115 116.219C205.614 115.719 205.333 115.041 205.333 114.333V71.6667C205.333 70.9594 205.614 70.2811 206.115 69.781C206.615 69.281 207.293 69 208 69ZM253.333 90.3333H210.667V111.667H253.333V90.3333ZM253.333 85V74.3333H210.667V85H253.333ZM237.333 101H248V106.333H237.333V101Z",
    fill: "#242423",
    fillOpacity: 0.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCircles);
export default __webpack_public_path__ + "static/media/card-circles.305dd6aca4b758b7ff3346a3462b52ea.svg";
export { ForwardRef as ReactComponent };